import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=dcba5378&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=ts&"
export * from "./Tag.vue?vue&type=script&lang=ts&"
import style0 from "./Tags.scss?vue&type=style&index=0&id=dcba5378&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcba5378",
  null
  
)

export default component.exports